import { z } from "zod";
import { CONFIRM_PASSWORD, OTP, NEW_PASSWORD } from "./consts";

export const schema = z.object({
  [OTP]: z.string().optional(),
  [NEW_PASSWORD]: z.string().optional(),
  [CONFIRM_PASSWORD]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
